import * as React from 'react'

import type { LucideIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import TooltipWrapper from '~/client/src/shared/components/TooltipWrapper/TooltipWrapper'

interface IProps {
  icon: LucideIcon
  label: string
  isEnabled: boolean
  tooltip: string | JSX.Element
  onClick: () => void
}

export default function UndoRedoAction({
  icon: Icon,
  label,
  isEnabled,
  tooltip,
  onClick,
}: IProps): JSX.Element {
  return (
    <TooltipWrapper className="ml4 no-select" content={tooltip}>
      <Button
        variant="primary-ghost"
        size="icon"
        aria-label={label}
        disabled={!isEnabled}
        onClick={onClick}
      >
        <Icon />
      </Button>
    </TooltipWrapper>
  )
}
